module.exports = __webpack_public_path__ + "img/logo.9f1af00c.png";